export default "__VITE_ASSET__pYX2HwdU__"